import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './locales/en';
import zhHant from './locales/zh-Hant';
import zhHans from './locales/zh-Hans';

const resources = {
  en: {
    translation: en
  },
  'zh-Hant': {
    translation: zhHant
  },
  'zh-Hans': {
    translation: zhHans
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'en', // default language
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false // react already safes from xss
    },
    react: {
      useSuspense: false
    }
  });

export default i18n;
